import { AnalyticsEvent } from '../models';

export class FindAChipotleClickEvent implements AnalyticsEvent {
  name = 'RestaurantLocatorClickEvent';

  constructor(public readonly eventType: string, public readonly restaurantId?: number, public readonly searchType?: string, public readonly searchInput?: string) {}
}
